// functionality of create-pack section on the subscripation page.
$(document).ready( function() {
  var productHandle = $('.create-pack-column').data('product-handle');
//console.log(productHandle);

  // I'M EXPECTING Button
  $(".btn-expecting").click(function (){
     $(".due-date").css("display", "block");
     $(".babys-age").css("display", "none");
     $(".main-create-pack").css("display", "none");
  });

  // I'M A MUM Button
  $(".btn-mum").click(function (){
     $(".due-date").css("display", "none");
     $(".babys-age").css("display", "block");
     $(".main-create-pack").css("display", "none");
  });

  // Next button
   // $('.row.product-detail-subscription').css("display", "block");
 // NEXT Button of I'M MUM
  $('.btn-next-birth-date').click(function(e) {
    e.preventDefault(); // Prevent the default action of the button
    $('.babys-age').css("display", "none");
    $(".disply-on-click-show-more").css("display", "none");
    // Check which radio button is selected
    var selectedRadio = $('input[name="stage"]:checked');

    if (selectedRadio.length > 0) {
      // Show or hide the corresponding div based on the selected radio button
      // $('.create-pack-column').css("display", "none"); // Hide all create-pack-column divs

      if (selectedRadio.val() === 'postpartum') {
        $('.row.product-detail-subscription').css("display", "block");
        $('.create-pack .more-options-subscription').css("display", "block");
        $('.create-pack-column[data-product-handle="postpartum-mum-set"]').css("display", "none");
        $('.create-pack-column[data-product-handle="mum-set"]').css("display", "none");
        $('.create-pack-column[data-product-handle="newborn-mum-set"]').css("display", "none");
        $('.create-pack-column[data-product-handle="naked-cream"]').css("display", "none");
        $('.create-pack-column[data-product-handle="the-cream"]').css("display", "none");
        $('.create-pack-column[data-product-handle="restore-your-skin-set"]').css("display", "none");
        $('.create-pack-column[data-product-handle="fresh-baby-set"]').css("display", "none");
        $('.create-pack-column[data-product-handle="baby-gift-set"]').css("display", "none");
        $('.create-pack-column[data-product-handle="mum-edition-mini-set"]').css("display", "none");
        $('.create-pack-column[data-product-handle="all-day-glow-set"]').css("display", "none");
        $('.create-pack-row[data-product-handle="postpartum-mum-set"]').css("display", "block");
        $('.create-pack-row[data-product-handle="mum-set"]').css("display", "none");
        $('.create-pack-row[data-product-handle="newborn-mum-set"]').css("display", "none");
        $('.create-pack-row[data-product-handle="naked-cream"]').css("display", "none");
        $('.create-pack-row[data-product-handle="the-cream"]').css("display", "none");
        $('.create-pack-row[data-product-handle="restore-your-skin-set"]').css("display", "none");
        $('.create-pack-row[data-product-handle="fresh-baby-set"]').css("display", "none");
        $('.create-pack-row[data-product-handle="baby-gift-set"]').css("display", "none");
        $('.create-pack-row[data-product-handle="mum-edition-mini-set"]').css("display", "none");
        $('.create-pack-row[data-product-handle="all-day-glow-set"]').css("display", "none");
        $('span[data-which="postpartum"]').css("display", "block");
        $('span[data-which="newborn"]').css("display", "none");
        $('span[data-which="infant"]').css("display", "none");
        $('span[data-which="toddler"]').css("display", "none");
      } else if (selectedRadio.val() === 'newborn') {
        $('.row.product-detail-subscription').css("display", "block");
        $('.create-pack .more-options-subscription').css("display", "block");
        $('.create-pack-column[data-product-handle="newborn-mum-set"]').css("display", "none");
        $('.create-pack-column[data-product-handle="postpartum-mum-set"]').css("display", "none");
        $('.create-pack-column[data-product-handle="mum-set"]').css("display", "none");
        $('.create-pack-column[data-product-handle="naked-cream"]').css("display", "none");
        $('.create-pack-column[data-product-handle="the-cream"]').css("display", "none");
        $('.create-pack-column[data-product-handle="restore-your-skin-set"]').css("display", "none");
        $('.create-pack-column[data-product-handle="fresh-baby-set"]').css("display", "none");
        $('.create-pack-column[data-product-handle="baby-gift-set"]').css("display", "none");
        $('.create-pack-column[data-product-handle="mum-edition-mini-set"]').css("display", "none");
        $('.create-pack-column[data-product-handle="all-day-glow-set"]').css("display", "none");
        $('.create-pack-row[data-product-handle="postpartum-mum-set"]').css("display", "none");
        $('.create-pack-row[data-product-handle="mum-set"]').css("display", "none");
        $('.create-pack-row[data-product-handle="newborn-mum-set"]').css("display", "block");
        $('.create-pack-row[data-product-handle="naked-cream"]').css("display", "none");
        $('.create-pack-row[data-product-handle="the-cream"]').css("display", "none");
        $('.create-pack-row[data-product-handle="restore-your-skin-set"]').css("display", "none");
        $('.create-pack-row[data-product-handle="fresh-baby-set"]').css("display", "none");
        $('.create-pack-row[data-product-handle="baby-gift-set"]').css("display", "none");
        $('.create-pack-row[data-product-handle="mum-edition-mini-set"]').css("display", "none");
        $('.create-pack-row[data-product-handle="all-day-glow-set"]').css("display", "none");
        $('span[data-which="newborn"]').css("display", "block");
        $('span[data-which="postpartum"]').css("display", "none");
        $('span[data-which="infant"]').css("display", "none");
        $('span[data-which="toddler"]').css("display", "none");
      } else if (selectedRadio.val() === 'infant') {
        $('.row.product-detail-subscription').css("display", "block");
        $('.create-pack .more-options-subscription').css("display", "block");
        $('.create-pack-column[data-product-handle="naked-cream"]').css("display", "none");
        $('.create-pack-column[data-product-handle="postpartum-mum-set"]').css("display", "none");
        $('.create-pack-column[data-product-handle="mum-set"]').css("display", "none");
        $('.create-pack-column[data-product-handle="newborn-mum-set"]').css("display", "none");
        $('.create-pack-column[data-product-handle="the-cream"]').css("display", "none");
        $('.create-pack-column[data-product-handle="restore-your-skin-set"]').css("display", "none");
        $('.create-pack-column[data-product-handle="fresh-baby-set"]').css("display", "none");
        $('.create-pack-column[data-product-handle="baby-gift-set"]').css("display", "none");
        $('.create-pack-column[data-product-handle="mum-edition-mini-set"]').css("display", "none");
        $('.create-pack-column[data-product-handle="all-day-glow-set"]').css("display", "none");
        $('.create-pack-row[data-product-handle="postpartum-mum-set"]').css("display", "none");
        $('.create-pack-row[data-product-handle="mum-set"]').css("display", "none");
        $('.create-pack-row[data-product-handle="newborn-mum-set"]').css("display", "none");
        $('.create-pack-row[data-product-handle="naked-cream"]').css("display", "block");
        $('.create-pack-row[data-product-handle="the-cream"]').css("display", "none");
        $('.create-pack-row[data-product-handle="restore-your-skin-set"]').css("display", "none");
        $('.create-pack-row[data-product-handle="fresh-baby-set"]').css("display", "none");
        $('.create-pack-row[data-product-handle="baby-gift-set"]').css("display", "none");
        $('.create-pack-row[data-product-handle="mum-edition-mini-set"]').css("display", "none");
        $('.create-pack-row[data-product-handle="all-day-glow-set"]').css("display", "none");
        $('span[data-which="infant"]').css("display", "block");
        $('span[data-which="newborn"]').css("display", "none");
        $('span[data-which="postpartum"]').css("display", "none");
        $('span[data-which="toddler"]').css("display", "none");
      } else if (selectedRadio.val() === 'toddler') {
        $('.row.product-detail-subscription').css("display", "block");
        $('.create-pack .more-options-subscription').css("display", "block");
        $('.create-pack-column[data-product-handle="the-cream"]').css("display", "none");
        $('.create-pack-column[data-product-handle="postpartum-mum-set"]').css("display", "none");
        $('.create-pack-column[data-product-handle="mum-set"]').css("display", "none");
        $('.create-pack-column[data-product-handle="newborn-mum-set"]').css("display", "none");
        $('.create-pack-column[data-product-handle="naked-cream"]').css("display", "none");
        $('.create-pack-column[data-product-handle="restore-your-skin-set"]').css("display", "none");
        $('.create-pack-column[data-product-handle="fresh-baby-set"]').css("display", "none");
        $('.create-pack-column[data-product-handle="baby-gift-set"]').css("display", "none");
        $('.create-pack-column[data-product-handle="mum-edition-mini-set"]').css("display", "none");
        $('.create-pack-column[data-product-handle="all-day-glow-set"]').css("display", "none");
        $('.create-pack-row[data-product-handle="postpartum-mum-set"]').css("display", "none");
        $('.create-pack-row[data-product-handle="mum-set"]').css("display", "none");
        $('.create-pack-row[data-product-handle="newborn-mum-set"]').css("display", "none");
        $('.create-pack-row[data-product-handle="naked-cream"]').css("display", "none");
        $('.create-pack-row[data-product-handle="the-cream"]').css("display", "block");
        $('.create-pack-row[data-product-handle="restore-your-skin-set"]').css("display", "none");
        $('.create-pack-row[data-product-handle="fresh-baby-set"]').css("display", "none");
        $('.create-pack-row[data-product-handle="baby-gift-set"]').css("display", "none");
        $('.create-pack-row[data-product-handle="mum-edition-mini-set"]').css("display", "none");
        $('.create-pack-row[data-product-handle="all-day-glow-set"]').css("display", "none");
        $('span[data-which="toddler"]').css("display", "block");
        $('span[data-which="infant"]').css("display", "none");
        $('span[data-which="newborn"]').css("display", "none");
        $('span[data-which="postpartum"]').css("display", "none");
      }
    }
  });

  // Show more options click button of I'M MUM
  $('.show-more-btn').click(function(){
    $(".disply-on-click-show-more").css("display", "block");
    $(".show-more-btn").css("display", "none");
    $(".label-top-pick").css("display","none");
    var selectedRadio = $('input[name="stage"]:checked');
    if (selectedRadio.length > 0) {
      if (selectedRadio.val() === 'postpartum') {
       // $('.row.product-detail-subscription').css("display", "block");
        //$('.create-pack .more-options-subscription').css("display", "block");
        $('.create-pack-column[data-product-handle="postpartum-mum-set"]').css("display", "none");
        $('.create-pack-column[data-product-handle="mum-set"]').css("display", "block");
        $('.create-pack-column[data-product-handle="newborn-mum-set"]').css("display", "none");
        $('.create-pack-column[data-product-handle="naked-cream"]').css("display", "none");
        $('.create-pack-column[data-product-handle="the-cream"]').css("display", "none");
        $('.create-pack-column[data-product-handle="restore-your-skin-set"]').css("display", "block");
        $('.create-pack-column[data-product-handle="fresh-baby-set"]').css("display", "none");
        $('.create-pack-column[data-product-handle="baby-gift-set"]').css("display", "none");
        $('.create-pack-column[data-product-handle="mum-edition-mini-set"]').css("display", "none");
        $('.create-pack-column[data-product-handle="all-day-glow-set"]').css("display", "none");
        $('.create-pack-row[data-product-handle="postpartum-mum-set"]').css("display", "none");
        $('.create-pack-row[data-product-handle="mum-set"]').css("display", "none");
        $('.create-pack-row[data-product-handle="newborn-mum-set"]').css("display", "none");
        $('.create-pack-row[data-product-handle="naked-cream"]').css("display", "none");
        $('.create-pack-row[data-product-handle="the-cream"]').css("display", "none");
        $('.create-pack-row[data-product-handle="restore-your-skin-set"]').css("display", "none");
        $('.create-pack-row[data-product-handle="fresh-baby-set"]').css("display", "none");
        $('.create-pack-row[data-product-handle="baby-gift-set"]').css("display", "none");
        $('.create-pack-row[data-product-handle="mum-edition-mini-set"]').css("display", "none");
        $('.create-pack-row[data-product-handle="all-day-glow-set"]').css("display", "none");
        $('span[data-which="postpartum"]').css("display", "none");
        $('span[data-which="newborn"]').css("display", "none");
        $('span[data-which="infant"]').css("display", "none");
        $('span[data-which="toddler"]').css("display", "none");
      } else if (selectedRadio.val() === 'newborn') {
        // $('.row.product-detail-subscription').css("display", "block");
        // $('.create-pack .more-options-subscription').css("display", "block");
        $('.create-pack-column[data-product-handle="newborn-mum-set"]').css("display", "none");
        $('.create-pack-column[data-product-handle="postpartum-mum-set"]').css("display", "none");
        $('.create-pack-column[data-product-handle="mum-set"]').css("display", "none");
        $('.create-pack-column[data-product-handle="naked-cream"]').css("display", "none");
        $('.create-pack-column[data-product-handle="the-cream"]').css("display", "none");
        $('.create-pack-column[data-product-handle="restore-your-skin-set"]').css("display", "none");
        $('.create-pack-column[data-product-handle="fresh-baby-set"]').css("display", "block");
        $('.create-pack-column[data-product-handle="baby-gift-set"]').css("display", "block");
        $('.create-pack-column[data-product-handle="mum-edition-mini-set"]').css("display", "none");
        $('.create-pack-column[data-product-handle="all-day-glow-set"]').css("display", "none");
        $('.create-pack-row[data-product-handle="postpartum-mum-set"]').css("display", "none");
        $('.create-pack-row[data-product-handle="mum-set"]').css("display", "none");
        $('.create-pack-row[data-product-handle="newborn-mum-set"]').css("display", "none");
        $('.create-pack-row[data-product-handle="naked-cream"]').css("display", "none");
        $('.create-pack-row[data-product-handle="the-cream"]').css("display", "none");
        $('.create-pack-row[data-product-handle="restore-your-skin-set"]').css("display", "none");
        $('.create-pack-row[data-product-handle="fresh-baby-set"]').css("display", "none");
        $('.create-pack-row[data-product-handle="baby-gift-set"]').css("display", "none");
        $('.create-pack-row[data-product-handle="mum-edition-mini-set"]').css("display", "none");
        $('.create-pack-row[data-product-handle="all-day-glow-set"]').css("display", "none");
        $('span[data-which="newborn"]').css("display", "none");
        $('span[data-which="postpartum"]').css("display", "none");
        $('span[data-which="infant"]').css("display", "none");
        $('span[data-which="toddler"]').css("display", "none");
      } else if (selectedRadio.val() === 'infant') {
        // $('.row.product-detail-subscription').css("display", "block");
        // $('.create-pack .more-options-subscription').css("display", "block");
        $('.create-pack-column[data-product-handle="naked-cream"]').css("display", "none");
        $('.create-pack-column[data-product-handle="postpartum-mum-set"]').css("display", "none");
        $('.create-pack-column[data-product-handle="mum-set"]').css("display", "none");
        $('.create-pack-column[data-product-handle="newborn-mum-set"]').css("display", "none");
        $('.create-pack-column[data-product-handle="the-cream"]').css("display", "none");
        $('.create-pack-column[data-product-handle="restore-your-skin-set"]').css("display", "block");
        $('.create-pack-column[data-product-handle="fresh-baby-set"]').css("display", "none");
        $('.create-pack-column[data-product-handle="baby-gift-set"]').css("display", "block");
        $('.create-pack-column[data-product-handle="mum-edition-mini-set"]').css("display", "none");
        $('.create-pack-column[data-product-handle="all-day-glow-set"]').css("display", "none");
        $('.create-pack-row[data-product-handle="postpartum-mum-set"]').css("display", "none");
        $('.create-pack-row[data-product-handle="mum-set"]').css("display", "none");
        $('.create-pack-row[data-product-handle="newborn-mum-set"]').css("display", "none");
        $('.create-pack-row[data-product-handle="naked-cream"]').css("display", "none");
        $('.create-pack-row[data-product-handle="the-cream"]').css("display", "none");
        $('.create-pack-row[data-product-handle="restore-your-skin-set"]').css("display", "none");
        $('.create-pack-row[data-product-handle="fresh-baby-set"]').css("display", "none");
        $('.create-pack-row[data-product-handle="baby-gift-set"]').css("display", "none");
        $('.create-pack-row[data-product-handle="mum-edition-mini-set"]').css("display", "none");
        $('.create-pack-row[data-product-handle="all-day-glow-set"]').css("display", "none");
        $('span[data-which="infant"]').css("display", "none");
        $('span[data-which="newborn"]').css("display", "none");
        $('span[data-which="postpartum"]').css("display", "none");
        $('span[data-which="toddler"]').css("display", "none");
      } else if (selectedRadio.val() === 'toddler') {
        // $('.row.product-detail-subscription').css("display", "block");
        // $('.create-pack .more-options-subscription').css("display", "block");
        $('.create-pack-column[data-product-handle="the-cream"]').css("display", "none");
        $('.create-pack-column[data-product-handle="postpartum-mum-set"]').css("display", "none");
        $('.create-pack-column[data-product-handle="mum-set"]').css("display", "none");
        $('.create-pack-column[data-product-handle="newborn-mum-set"]').css("display", "none");
        $('.create-pack-column[data-product-handle="naked-cream"]').css("display", "none");
        $('.create-pack-column[data-product-handle="restore-your-skin-set"]').css("display", "none");
        $('.create-pack-column[data-product-handle="fresh-baby-set"]').css("display", "none");
        $('.create-pack-column[data-product-handle="baby-gift-set"]').css("display", "none");
        $('.create-pack-column[data-product-handle="mum-edition-mini-set"]').css("display", "block");
        $('.create-pack-column[data-product-handle="all-day-glow-set"]').css("display", "block");
        $('.create-pack-row[data-product-handle="postpartum-mum-set"]').css("display", "none");
        $('.create-pack-row[data-product-handle="mum-set"]').css("display", "none");
        $('.create-pack-row[data-product-handle="newborn-mum-set"]').css("display", "none");
        $('.create-pack-row[data-product-handle="naked-cream"]').css("display", "none");
        $('.create-pack-row[data-product-handle="the-cream"]').css("display", "none");
        $('.create-pack-row[data-product-handle="restore-your-skin-set"]').css("display", "none");
        $('.create-pack-row[data-product-handle="fresh-baby-set"]').css("display", "none");
        $('.create-pack-row[data-product-handle="baby-gift-set"]').css("display", "none");
        $('.create-pack-row[data-product-handle="mum-edition-mini-set"]').css("display", "none");
        $('.create-pack-row[data-product-handle="all-day-glow-set"]').css("display", "none");
        $('span[data-which="toddler"]').css("display", "none");
        $('span[data-which="infant"]').css("display", "none");
        $('span[data-which="newborn"]').css("display", "none");
        $('span[data-which="postpartum"]').css("display", "none");
      }
    }
  });

  // Show Top Pick button of I'M MUM
  $('.show-top-pick-btn').click(function(e){
   e.preventDefault(); // Prevent the default action of the button
    $('.babys-age').css("display", "none");
    $(".show-more-btn").css("display", "block");
    $(".disply-on-click-show-more").css("display", "none");
    $(".label-top-pick").css("display","block");
    // Check which radio button is selected
    var selectedRadio = $('input[name="stage"]:checked');

    if (selectedRadio.length > 0) {
      // Show or hide the corresponding div based on the selected radio button
      // $('.create-pack-column').css("display", "none"); // Hide all create-pack-column divs

      if (selectedRadio.val() === 'postpartum') {
        $('.row.product-detail-subscription').css("display", "block");
        $('.create-pack .more-options-subscription').css("display", "block");
        $('.create-pack-column[data-product-handle="postpartum-mum-set"]').css("display", "none");
        $('.create-pack-column[data-product-handle="mum-set"]').css("display", "none");
        $('.create-pack-column[data-product-handle="newborn-mum-set"]').css("display", "none");
        $('.create-pack-column[data-product-handle="naked-cream"]').css("display", "none");
        $('.create-pack-column[data-product-handle="the-cream"]').css("display", "none");
        $('.create-pack-column[data-product-handle="restore-your-skin-set"]').css("display", "none");
        $('.create-pack-column[data-product-handle="fresh-baby-set"]').css("display", "none");
        $('.create-pack-column[data-product-handle="baby-gift-set"]').css("display", "none");
        $('.create-pack-column[data-product-handle="mum-edition-mini-set"]').css("display", "none");
        $('.create-pack-column[data-product-handle="all-day-glow-set"]').css("display", "none");
        $('.create-pack-row[data-product-handle="postpartum-mum-set"]').css("display", "block");
        $('.create-pack-row[data-product-handle="mum-set"]').css("display", "none");
        $('.create-pack-row[data-product-handle="newborn-mum-set"]').css("display", "none");
        $('.create-pack-row[data-product-handle="naked-cream"]').css("display", "none");
        $('.create-pack-row[data-product-handle="the-cream"]').css("display", "none");
        $('.create-pack-row[data-product-handle="restore-your-skin-set"]').css("display", "none");
        $('.create-pack-row[data-product-handle="fresh-baby-set"]').css("display", "none");
        $('.create-pack-row[data-product-handle="baby-gift-set"]').css("display", "none");
        $('.create-pack-row[data-product-handle="mum-edition-mini-set"]').css("display", "none");
        $('.create-pack-row[data-product-handle="all-day-glow-set"]').css("display", "none");
        $('span[data-which="postpartum"]').css("display", "block");
        $('span[data-which="newborn"]').css("display", "none");
        $('span[data-which="infant"]').css("display", "none");
        $('span[data-which="toddler"]').css("display", "none");
      } else if (selectedRadio.val() === 'newborn') {
        $('.row.product-detail-subscription').css("display", "block");
        $('.create-pack .more-options-subscription').css("display", "block");
        $('.create-pack-column[data-product-handle="newborn-mum-set"]').css("display", "none");
        $('.create-pack-column[data-product-handle="postpartum-mum-set"]').css("display", "none");
        $('.create-pack-column[data-product-handle="mum-set"]').css("display", "none");
        $('.create-pack-column[data-product-handle="naked-cream"]').css("display", "none");
        $('.create-pack-column[data-product-handle="the-cream"]').css("display", "none");
        $('.create-pack-column[data-product-handle="restore-your-skin-set"]').css("display", "none");
        $('.create-pack-column[data-product-handle="fresh-baby-set"]').css("display", "none");
        $('.create-pack-column[data-product-handle="baby-gift-set"]').css("display", "none");
        $('.create-pack-column[data-product-handle="mum-edition-mini-set"]').css("display", "none");
        $('.create-pack-column[data-product-handle="all-day-glow-set"]').css("display", "none");
        $('.create-pack-row[data-product-handle="postpartum-mum-set"]').css("display", "none");
        $('.create-pack-row[data-product-handle="mum-set"]').css("display", "none");
        $('.create-pack-row[data-product-handle="newborn-mum-set"]').css("display", "block");
        $('.create-pack-row[data-product-handle="naked-cream"]').css("display", "none");
        $('.create-pack-row[data-product-handle="the-cream"]').css("display", "none");
        $('.create-pack-row[data-product-handle="restore-your-skin-set"]').css("display", "none");
        $('.create-pack-row[data-product-handle="fresh-baby-set"]').css("display", "none");
        $('.create-pack-row[data-product-handle="baby-gift-set"]').css("display", "none");
        $('.create-pack-row[data-product-handle="mum-edition-mini-set"]').css("display", "none");
        $('.create-pack-row[data-product-handle="all-day-glow-set"]').css("display", "none");
        $('span[data-which="newborn"]').css("display", "block");
        $('span[data-which="postpartum"]').css("display", "none");
        $('span[data-which="infant"]').css("display", "none");
        $('span[data-which="toddler"]').css("display", "none");
      } else if (selectedRadio.val() === 'infant') {
        $('.row.product-detail-subscription').css("display", "block");
        $('.create-pack .more-options-subscription').css("display", "block");
        $('.create-pack-column[data-product-handle="naked-cream"]').css("display", "none");
        $('.create-pack-column[data-product-handle="postpartum-mum-set"]').css("display", "none");
        $('.create-pack-column[data-product-handle="mum-set"]').css("display", "none");
        $('.create-pack-column[data-product-handle="newborn-mum-set"]').css("display", "none");
        $('.create-pack-column[data-product-handle="the-cream"]').css("display", "none");
        $('.create-pack-column[data-product-handle="restore-your-skin-set"]').css("display", "none");
        $('.create-pack-column[data-product-handle="fresh-baby-set"]').css("display", "none");
        $('.create-pack-column[data-product-handle="baby-gift-set"]').css("display", "none");
        $('.create-pack-column[data-product-handle="mum-edition-mini-set"]').css("display", "none");
        $('.create-pack-column[data-product-handle="all-day-glow-set"]').css("display", "none");
        $('.create-pack-row[data-product-handle="postpartum-mum-set"]').css("display", "none");
        $('.create-pack-row[data-product-handle="mum-set"]').css("display", "none");
        $('.create-pack-row[data-product-handle="newborn-mum-set"]').css("display", "none");
        $('.create-pack-row[data-product-handle="naked-cream"]').css("display", "block");
        $('.create-pack-row[data-product-handle="the-cream"]').css("display", "none");
        $('.create-pack-row[data-product-handle="restore-your-skin-set"]').css("display", "none");
        $('.create-pack-row[data-product-handle="fresh-baby-set"]').css("display", "none");
        $('.create-pack-row[data-product-handle="baby-gift-set"]').css("display", "none");
        $('.create-pack-row[data-product-handle="mum-edition-mini-set"]').css("display", "none");
        $('.create-pack-row[data-product-handle="all-day-glow-set"]').css("display", "none");
        $('span[data-which="infant"]').css("display", "block");
        $('span[data-which="newborn"]').css("display", "none");
        $('span[data-which="postpartum"]').css("display", "none");
        $('span[data-which="toddler"]').css("display", "none");
      } else if (selectedRadio.val() === 'toddler') {
        $('.row.product-detail-subscription').css("display", "block");
        $('.create-pack .more-options-subscription').css("display", "block");
        $('.create-pack-column[data-product-handle="the-cream"]').css("display", "none");
        $('.create-pack-column[data-product-handle="postpartum-mum-set"]').css("display", "none");
        $('.create-pack-column[data-product-handle="mum-set"]').css("display", "none");
        $('.create-pack-column[data-product-handle="newborn-mum-set"]').css("display", "none");
        $('.create-pack-column[data-product-handle="naked-cream"]').css("display", "none");
        $('.create-pack-column[data-product-handle="restore-your-skin-set"]').css("display", "none");
        $('.create-pack-column[data-product-handle="fresh-baby-set"]').css("display", "none");
        $('.create-pack-column[data-product-handle="baby-gift-set"]').css("display", "none");
        $('.create-pack-column[data-product-handle="mum-edition-mini-set"]').css("display", "none");
        $('.create-pack-column[data-product-handle="all-day-glow-set"]').css("display", "none");
        $('.create-pack-row[data-product-handle="postpartum-mum-set"]').css("display", "none");
        $('.create-pack-row[data-product-handle="mum-set"]').css("display", "none");
        $('.create-pack-row[data-product-handle="newborn-mum-set"]').css("display", "none");
        $('.create-pack-row[data-product-handle="naked-cream"]').css("display", "none");
        $('.create-pack-row[data-product-handle="the-cream"]').css("display", "block");
        $('.create-pack-row[data-product-handle="restore-your-skin-set"]').css("display", "none");
        $('.create-pack-row[data-product-handle="fresh-baby-set"]').css("display", "none");
        $('.create-pack-row[data-product-handle="baby-gift-set"]').css("display", "none");
        $('.create-pack-row[data-product-handle="mum-edition-mini-set"]').css("display", "none");
        $('.create-pack-row[data-product-handle="all-day-glow-set"]').css("display", "none");
        $('span[data-which="toddler"]').css("display", "block");
        $('span[data-which="infant"]').css("display", "none");
        $('span[data-which="newborn"]').css("display", "none");
        $('span[data-which="postpartum"]').css("display", "none");
      }
    }
  });

  // DESCRIPTION accordian on Show More Option section in side I'M MUM
  $('.desc-title').click(function (){
    $('.desc-content').toggleClass('active');
    $('.desc-title').toggleClass('minus');
  });

  // INGREDIANT accordian on Show More Option section in side I'M MUM
  $('.ingrediant-title').click(function (){
    $('.ingrediant-content').toggleClass('active');
    $('.ingrediant-title').toggleClass('minus');
  });

  // ETHOS accordian on Show More Option section in side I'M MUM
  $('.ethos-title').click(function (){
    $('.ethos-content').toggleClass('active');
    $('.ethos-title').toggleClass('minus');
  });

  // Calander picker insite I'M EXPECTING
   var today = new Date().toISOString().split("T")[0];

  // Set the minimum value for the date input field
  $(".txt-calendar").attr("min", today);
  // Event handler for date selection
  $(".txt-calendar").change(function() {
    var selectedDate = new Date($(this).val());
    var today = new Date();
  });

  // Event handler for "Next" button click inside I'M EXPECTING
  $(".btn-next-due-date").click(function(e) {
    e.preventDefault();
    var selectedDate = new Date($(".txt-calendar").val());
    var today = new Date();

    // Compare selected date with today's date
    if (selectedDate >= today || selectedDate.toDateString() === today.toDateString()) {
      $('.row.product-detail-subscription').css("display", "block");
      $('.create-pack-row[data-product-handle="mum-set"]').css("display", "block");
      $('.create-pack-row[data-product-handle="postpartum-mum-set"]').css("display", "none");
      $('.create-pack-row[data-product-handle="newborn-mum-set"]').css("display", "none");
      $('.create-pack-row[data-product-handle="naked-cream"]').css("display", "none");
      $('.create-pack-row[data-product-handle="the-cream"]').css("display", "none");
      $('.create-pack-row[data-product-handle="restore-your-skin-set"]').css("display", "none");
      $('.create-pack-row[data-product-handle="fresh-baby-set"]').css("display", "none");
      $('.create-pack-row[data-product-handle="baby-gift-set"]').css("display", "none");
      $('.create-pack-row[data-product-handle="mum-edition-mini-set"]').css("display", "none");
      $('.create-pack-row[data-product-handle="all-day-glow-set"]').css("display", "none");
      $('.due-date').css("display", "none");
      
      // Show More Option button click inside I'M EXPECTING
      $('.show-more-btn').click(function(){
        $('.row.product-detail-subscription').css("display", "none");
        $(".disply-on-click-show-more").css("display", "block");
        $(".show-more-btn").css("display", "none");
        $(".label-top-pick").css("display","none");
        $('.create-pack .more-options-subscription').css("display", "block");
        $('.create-pack-column[data-product-handle="restore-your-skin-set"]').css("display", "block");
        $('.create-pack-column[data-product-handle="fresh-baby-set"]').css("display", "block");
        $('.create-pack-column[data-product-handle="naked-cream"]').css("display", "none");
        $('.create-pack-column[data-product-handle="postpartum-mum-set"]').css("display", "none");
        $('.create-pack-column[data-product-handle="mum-set"]').css("display", "none");
        $('.create-pack-column[data-product-handle="newborn-mum-set"]').css("display", "none");
        $('.create-pack-column[data-product-handle="the-cream"]').css("display", "none");
        $('.create-pack-column[data-product-handle="baby-gift-set"]').css("display", "none");
        $('.create-pack-column[data-product-handle="mum-edition-mini-set"]').css("display", "none");
        $('.create-pack-column[data-product-handle="all-day-glow-set"]').css("display", "none");
      });

      // Show Top Pick button click inside I'M EXPECTING
      $('.show-top-pick-btn').click(function(){
        $(".show-more-btn").css("display", "block");
        $(".disply-on-click-show-more").css("display", "none");
        $(".label-top-pick").css("display","block");
        $('.row.product-detail-subscription').css("display", "block");
        $('.create-pack-row[data-product-handle="mum-set"]').css("display", "block");
        $('.create-pack-row[data-product-handle="postpartum-mum-set"]').css("display", "none");
        $('.create-pack-row[data-product-handle="newborn-mum-set"]').css("display", "none");
        $('.create-pack-row[data-product-handle="naked-cream"]').css("display", "none");
        $('.create-pack-row[data-product-handle="the-cream"]').css("display", "none");
        $('.create-pack-row[data-product-handle="restore-your-skin-set"]').css("display", "none");
        $('.create-pack-row[data-product-handle="fresh-baby-set"]').css("display", "none");
        $('.create-pack-row[data-product-handle="baby-gift-set"]').css("display", "none");
        $('.create-pack-row[data-product-handle="mum-edition-mini-set"]').css("display", "none");
        $('.create-pack-row[data-product-handle="all-day-glow-set"]').css("display", "none");
        $('.create-pack-column[data-product-handle="restore-your-skin-set"]').css("display", "none");
        $('.create-pack-column[data-product-handle="fresh-baby-set"]').css("display", "none");
        $('.create-pack-column[data-product-handle="naked-cream"]').css("display", "none");
        $('.create-pack-column[data-product-handle="postpartum-mum-set"]').css("display", "none");
        $('.create-pack-column[data-product-handle="mum-set"]').css("display", "none");
        $('.create-pack-column[data-product-handle="newborn-mum-set"]').css("display", "none");
        $('.create-pack-column[data-product-handle="the-cream"]').css("display", "none");
        $('.create-pack-column[data-product-handle="baby-gift-set"]').css("display", "none");
        $('.create-pack-column[data-product-handle="mum-edition-mini-set"]').css("display", "none");
        $('.create-pack-column[data-product-handle="all-day-glow-set"]').css("display", "none");
      });
    }
  });
});